import { getStripeFieldsOptions } from '../stripe-payment-methods/components/StripePaymentMethods';

export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { projectId, collections, pageCollection } = config;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: `<i class="wb webconnect-table"></i>`,
          projectId: projectId,
          traits: [
            {
              name: 'stripe-customer-id-collection',
              type: 'select',
              label: 'Stripe Customer Id Collection',
              options: [
                { value: '', name: '-- Select --' },
                { value: 'PAGE_COLLECTION', name: 'Page Collection' },
                { value: 'CURRENT_USER', name: 'Current LoggedIn User Collection' },
              ],
              changeProp: 1,
            },
          ],
          script: function () {
            if (typeof randerPaymentMethodList !== 'undefined') {
              randerPaymentMethodList(this);
            }
          },
        },
        init() {
          const attrs = this.getAttributes();
          const stripeField = attrs['stripe-customer-id-field'];
          if (stripeField) this.handleStripeCustomerIdCollectionChange();

          this.on(
            'change:stripe-customer-id-collection',
            this.handleStripeCustomerIdCollectionChange,
          );
          this.on('change:stripe-customer-id-field', this.handleStripeCustomerIdFieldChange);
        },
        async handleStripeCustomerIdCollectionChange() {
          const stripeCollection = this.get('stripe-customer-id-collection');
          const attrs = this.getAttributes();
          attrs['stripe-customer-id-collection'] = stripeCollection;
          this.setAttributes(attrs);
          const fieldOptions = await getStripeFieldsOptions(
            stripeCollection,
            collections,
            pageCollection,
          );
          this.removeTrait('stripe-customer-id-field');
          const fieldTrait = {
            type: 'select',
            label: 'Customer Id Field',
            name: 'stripe-customer-id-field',
            changeProp: 1,
            options: fieldOptions,
            value: '',
          };
          this.addTrait(fieldTrait, {
            at: this.getTraitIndex('stripe-customer-id-collection') + 1,
          });
        },
        handleStripeCustomerIdFieldChange() {
          const stripeField = this.get('stripe-customer-id-field');
          const attrs = this.getAttributes();
          attrs['stripe-customer-id-field'] = stripeField;
          this.setAttributes(attrs);
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:stripe-customer-id-collection', this.updateScript);
        this.listenTo(model, 'change:stripe-customer-id-field', this.updateScript);
      },
    }),
  });
};
